import { Link, LinkProps } from '@chakra-ui/react';
import { useTheme } from '../../contexts/ThemeProvider';
import { APP_EVENTS, spawnAppEvent } from '../../mobileEvents';

export function ExternalLink({ to, ...props }: { to: string } & LinkProps) {
  const { isApp } = useTheme();

  function onClick() {
    const link = to.includes('http') ? to : 'https://' + window.location.host + to;

    spawnAppEvent(APP_EVENTS.OPEN_LINK, link);
  }

  if (isApp) {
    return <Link width={'100%'} onClick={onClick} {...props}></Link>;
  } else {
    return <Link w={'100%'} href={to} isExternal {...props}></Link>;
  }
}
